export default {
  title: 'Richieste di cancellazione dati',
  fields: {
    created_at: 'Richiesta il',
    restaurant: 'Ristorante',
    customer: 'Cliente',
    note: 'Nota',
    status: 'Stato',
    completed_by: 'Completato da',
    actions: 'Azioni',
  },
  statuses: {
    pending: 'In attesa',
    completed: 'Completate',
  },
  buttons: {
    approve: 'Approva',
  },
  modals: {
    approve: {
      title: "Approvare l'eliminazione dei dati per {{name}}?",
      description:
        'Questa operazione elimina definitivamente i dati personali del cliente e non può essere annullata. La richiesta verrà contrassegnata come completata.',
    },
  },
  toasts: {
    failed_to_load_data: 'Caricamento dati non riuscito',
    failed_to_approve: 'Approvazione della richiesta non riuscita',
    approved: 'Richiesta approvata e dati eliminati',
  },
};
